<script setup>
import { useRouter } from 'vue-router'
import ScheduledItemCard from '@/components/scheduled/ScheduledItemCard.vue'

const props = defineProps({
  items: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  // Id del messaggio appena creato: il suo toggle pulsa per qualche secondo.
  highlightId: { type: [String, Number], default: null },
})

const emit = defineEmits(['toggle-active', 'delete'])
const router = useRouter()

const onToggle = (item, val) => {
  emit('toggle-active', item, val)
}

const onDelete = (item) => {
  emit('delete', item)
}

const onEdit = (item) => {
  router.push({
    query: { edit: item.id }
  })
}
</script>

<template>
  <div>
    <div class="q-gutter-y-md">
      <ScheduledItemCard
        v-for="item in props.items"
        :key="item.id"
        :item="item"
        :highlight-toggle="props.highlightId !== null && item.id === props.highlightId"
        @toggle="onToggle"
        @edit="onEdit"
        @delete="onDelete"
      />

      <q-card
        v-if="!props.loading && (!props.items || props.items.length === 0)"
        class="text-center q-pa-lg bg-grey-1 dashed-border"
      >
        <q-card-section>
          <div class="text-grey-6">
            {{ $t('scheduled.list.empty') }}
          </div>
        </q-card-section>
      </q-card>
    </div>

    <q-inner-loading :showing="props.loading">
      <q-spinner
        color="primary"
        size="3em"
      />
    </q-inner-loading>
  </div>
</template>
